import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, shareReplay, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class CatalogosApiService {

  constructor(private http: HttpClient) { }

  getPuestos(): Observable<any> {
    return this.http
      .get<any>(`${environment.apiCatalogos}/v1/catalogos/puestos?clavePais=MX`)
      .pipe(shareReplay(1))
  }

  getSueldos(): Observable<any> {
    return this.http
      .get<any>(`${environment.apiCatalogos}/v1/catalogos/sueldos?idPais=38`)
      .pipe(shareReplay(1))
  }

  getEntidadesFederativas(): Observable<any> {
    return this.http
      .get<any>(`${environment.apiCatalogos}/v1/catalogos/entidades?clavePais=MX`)
      .pipe(shareReplay(1))
  }

  getLocalidades(entidadFederativa: string): Observable<any> {
    return this.http
      .get<any>(`${environment.apiCatalogos}/v1/catalogos/localidades?clavePais=MX&idEntidad=${entidadFederativa}`)
      .pipe(shareReplay(1))
  }

  getTipoCursos() {
    return this.http
      .get<any>(`${environment.urlApiCandidato}/catalogo/tipos-curso`)
      .pipe(shareReplay(1))
  }
}